export type BlogPost = {
  slug: string;
  title: string;
  description: string;
  datePublished: string;
  dateModified?: string;
  excerpt: string;
  sections: Array<{ heading: string; body?: string; bullets?: string[] }>;
};

export const POSTS: BlogPost[] = [
  {
    slug: "ai-per-avvocati-italia-2026",
    title: "AI per avvocati in Italia nel 2026",
    description: "Panoramica aggiornata sull'adozione dell'intelligenza artificiale negli studi legali italiani e cosa serve sapere oggi.",
    datePublished: "2026-01-15",
    excerpt: "Negli ultimi 18 mesi l'AI è passata da curiosità a strumento operativo per migliaia di studi italiani. Ecco cosa è cambiato.",
    sections: [
      { heading: "Adozione: dai pionieri alla normalità", body: "Secondo dati di settore, oltre il 35% degli studi italiani con più di 5 professionisti utilizza almeno uno strumento di AI generativa nelle attività quotidiane. Il dato era inferiore al 10% nel 2024." },
      { heading: "Cosa funziona davvero", bullets: ["Ricerca normativa con citazioni","Sintesi di fascicoli e atti","Prima bozza di contratti standard","Estrazione clausole in due diligence"] },
      { heading: "Cosa ancora non funziona", body: "L'AI non sostituisce il giudizio. Strategia processuale, scelte deontologiche e rapporto col cliente restano competenze umane." },
    ],
  },
  {
    slug: "come-scegliere-strumento-ai-legale",
    title: "Come scegliere un'AI per lo studio legale",
    description: "Cinque criteri pratici per valutare un software di AI legale: citazioni, privacy, integrazione, costo, supporto.",
    datePublished: "2026-02-10",
    excerpt: "Non tutti gli strumenti AI sono uguali. Una checklist concreta per non sbagliare scelta.",
    sections: [
      { heading: "1. Citazioni verificabili", body: "Senza citazioni, l'output non è utilizzabile. Verifica che ogni risposta sia ancorata a una fonte normativa o giurisprudenziale apribile." },
      { heading: "2. Privacy e zero retention", body: "I tuoi documenti contengono segreto professionale. Lo strumento deve garantire non addestramento sui tuoi dati e cancellazione dopo l'elaborazione." },
      { heading: "3. Specializzazione", body: "Un modello generalista non basta. Cerca soluzioni costruite sul corpus normativo italiano." },
      { heading: "4. Integrazione e workflow", body: "L'AI deve entrare nel tuo flusso di lavoro: gestione pratiche, calendario, redazione, esportazione PDF." },
      { heading: "5. Supporto e roadmap", body: "Un fornitore italiano, con team di prodotto raggiungibile, fa la differenza nei primi 90 giorni." },
    ],
  },
  {
    slug: "ai-act-cosa-deve-sapere-avvocato",
    title: "AI Act: cosa deve sapere ogni avvocato che usa AI",
    description: "Una guida pratica al Regolamento UE 2024/1689 per professionisti legali: obblighi, scadenze, classificazione.",
    datePublished: "2026-02-25",
    excerpt: "L'AI Act non riguarda solo i fornitori. Anche gli utilizzatori professionali hanno obblighi specifici.",
    sections: [
      { heading: "Quando si applica", body: "Il Regolamento è pienamente applicabile dal 2 agosto 2026. Alcuni obblighi sono già in vigore." },
      { heading: "Obblighi per gli avvocati utilizzatori", bullets: ["Trasparenza verso clienti sull'uso di AI","Supervisione umana documentabile","Conservazione dei log significativi","Valutazione di impatto in casi a rischio"] },
      { heading: "Come LexAIPro aiuta", body: "Forniamo logging, indicazione esplicita degli output AI e documentazione tecnica conforme." },
    ],
  },
];

export function getPost(slug: string) {
  return POSTS.find((p) => p.slug === slug);
}
